<!-- ── Hero with profile showcase ── -->
<section class="hero">
  <div class="hero-inner">
    <!-- Profile card overlapping the hero -->
    <div class="profile-showcase">
      <div class="avatar-ring">
        <img [src]="user?.profilePhoto || 'images/profile-placeholder.png'" alt="Profile Photo" class="avatar-img" />
        <button *ngIf="!readOnlySso" class="avatar-edit" (click)="fileInput.click()" title="Change photo">
          <mat-icon>photo_camera</mat-icon>
        </button>
        <input type="file" #fileInput accept="image/*" hidden (change)="onFileSelected($event)" />
      </div>
      <h1 class="profile-name">{{ user?.firstname }} {{ user?.lastname }}</h1>
      <p class="profile-title">{{ user?.jobTitle }}</p>
      <div class="profile-badges">
        <span class="badge"><mat-icon>business</mat-icon>{{ user?.company }}</span>
        <span class="badge"><mat-icon>shield</mat-icon>{{ user?.roles?.join(', ') }}</span>
      </div>
    </div>
  </div>

</section>

<div class="account-container">

  <!-- Alerts -->
  <div *ngIf="updateSuccess" class="alert alert-success">
    <mat-icon>check_circle</mat-icon> Account details updated successfully!
  </div>
  <div *ngIf="error" class="alert alert-error">
    <mat-icon>error</mat-icon> {{ error }}
  </div>
  <div *ngIf="readOnlySso" class="alert alert-success">
    <mat-icon>visibility</mat-icon> Microsoft SSO profiles are read-only.
  </div>

  <!-- ── Two-column layout ── -->
  <div class="content-grid">

    <!-- LEFT COLUMN -->
    <div class="col-left">

      <!-- Account Overview (combined) -->
      <div class="card">
        <div class="card-header">
          <mat-icon>person</mat-icon>
          <h3>Account Overview</h3>
        </div>
        <div class="card-body">
          <div class="field">
            <label>First Name</label>
            <div class="input-wrap">
              <mat-icon class="input-icon">person</mat-icon>
              <input type="text" [(ngModel)]="user.firstname" placeholder="First name" [readonly]="readOnlySso" />
            </div>
          </div>
          <div class="field">
            <label>Last Name</label>
            <div class="input-wrap">
              <mat-icon class="input-icon">person</mat-icon>
              <input type="text" [(ngModel)]="user.lastname" placeholder="Last name" [readonly]="readOnlySso" />
            </div>
          </div>
          <div class="field">
            <label>Email</label>
            <div class="input-wrap">
              <mat-icon class="input-icon">mail</mat-icon>
              <input type="email" [(ngModel)]="user.email" placeholder="you@company.com" [readonly]="readOnlySso" />
            </div>
          </div>
          <div class="field">
            <label>Phone Number</label>
            <div class="input-wrap">
              <mat-icon class="input-icon">phone</mat-icon>
              <input type="text" [(ngModel)]="user.phoneNumber"
                     (blur)="user.phoneNumber = formatPhone(user.phoneNumber)"
                     [readonly]="readOnlySso"
                     placeholder="555-123-4567" />
            </div>
          </div>
          <div class="field">
            <label>Job Title</label>
            <div class="input-wrap">
              <mat-icon class="input-icon">work</mat-icon>
              <input type="text" [(ngModel)]="user.jobTitle" placeholder="Your title" [readonly]="readOnlySso" />
            </div>
          </div>
          <div class="info-item">
            <span class="info-label">Company</span>
            <span class="info-value">{{ user?.company }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">Roles</span>
            <span class="info-value">{{ user?.roles?.join(', ') }}</span>
          </div>
          <button *ngIf="!readOnlySso" class="btn-primary full-width" (click)="saveChanges()">
            <mat-icon>save</mat-icon> Save Changes
          </button>
        </div>
      </div>

    </div>

    <!-- RIGHT COLUMN -->
    <div class="col-right">

      <!-- Company Logo -->
      <div class="card">
        <div class="card-header">
          <mat-icon>apartment</mat-icon>
          <h3>Company Logo</h3>
        </div>
        <div class="card-body logo-body">
          <div class="logo-frame">
            <img *ngIf="companyLogo" [src]="companyLogo" alt="Company Logo" class="logo-img" />
            <mat-icon *ngIf="!companyLogo" class="logo-empty">apartment</mat-icon>
          </div>
          <button *ngIf="!readOnlySso" class="btn-outline full-width" (click)="fileInputLogo.click()">
            <mat-icon>cloud_upload</mat-icon> Upload New Logo
          </button>
          <input type="file" #fileInputLogo accept=".jpg,.jpeg,.png" hidden (change)="onFileSelectedLogo($event)" />
        </div>
      </div>

      <!-- Security -->
      <div *ngIf="!readOnlySso" class="card">
        <div class="card-header">
          <mat-icon>shield</mat-icon>
          <h3>Security</h3>
        </div>
        <div class="card-body">
          <div class="security-row">
            <div class="security-info">
              <span class="security-label">Password</span>
              <span class="security-value">••••••••••</span>
            </div>
            <button class="btn-outline-sm" (click)="openPasswordChangeDialog()">
              <mat-icon>vpn_key</mat-icon> Change
            </button>
          </div>
        </div>
      </div>

      <!-- Installations -->
      <div class="card">
        <div class="card-header">
          <mat-icon>install_desktop</mat-icon>
          <h3>Installations</h3>
        </div>
        <div class="card-body install-body">
          <div class="install-row">
            <div class="install-info">
              <mat-icon class="install-icon">description</mat-icon>
              <div>
                <span class="install-name">DSDN Tekla Macro</span>
                <span class="install-desc">Tekla macro installer</span>
              </div>
            </div>
            <button class="btn-outline-sm" (click)="downloadInstaller()" [disabled]="isDownloading">
              <mat-icon>{{ isDownloading ? 'hourglass_empty' : 'download' }}</mat-icon>
              {{ isDownloading ? 'Downloading…' : 'Download' }}
            </button>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>

<!-- ── Password Modal ── -->
<div class="modal-backdrop" *ngIf="showPasswordChangeDialog" (click)="closePasswordChangeDialog()"></div>
<div class="modal-dialog" *ngIf="showPasswordChangeDialog" (click)="$event.stopPropagation()">
  <div class="modal-content">
    <div class="modal-header">
      <div class="modal-title"><mat-icon>lock</mat-icon> Update Password</div>
      <button class="close-btn" (click)="closePasswordChangeDialog()">&times;</button>
    </div>
    <div class="modal-body">
      <div class="field">
        <label>Current Password</label>
        <div class="input-wrap">
          <mat-icon class="input-icon">lock_open</mat-icon>
          <input type="password" id="currentPassword" [(ngModel)]="currentPassword" placeholder="Enter current password" required>
        </div>
      </div>
      <div class="field">
        <label>New Password</label>
        <div class="input-wrap">
          <mat-icon class="input-icon">vpn_key</mat-icon>
          <input type="password" id="newPassword" [(ngModel)]="newPassword" placeholder="Enter new password" required>
        </div>
      </div>
      <div class="field">
        <label>Confirm Password</label>
        <div class="input-wrap">
          <mat-icon class="input-icon">vpn_key</mat-icon>
          <input type="password" id="confirmPassword" [(ngModel)]="confirmPassword" placeholder="Confirm new password" required>
        </div>
      </div>
      <div *ngIf="passwordError" class="alert alert-error" style="margin-top: 0.75rem;">
        <mat-icon>error</mat-icon> {{ passwordError }}
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn-ghost" (click)="closePasswordChangeDialog()">Cancel</button>
      <button class="btn-primary" (click)="updatePassword()">
        <mat-icon>lock</mat-icon> Update Password
      </button>
    </div>
  </div>
</div>
